import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { recruitmentCompanyService } from '../../services/recruitmentCompanyService';
import { authService } from '../../services/authService';
import { STORAGE_BASE_URL } from '../../config/api';
import RecruitmentCompanyNav from '../../components/RecruitmentCompanyNav';
import RecruitmentCompanyBottomNavigation from '../../components/RecruitmentCompanyBottomNavigation';
import Loader from '../../components/Loader';
import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';

const RecruitmentCompanyProfile = () => {
    const user = authService.getCurrentUser();
    const { t, locale } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState({
        name: '',
        bio: '',
        address: '',
        site_link: '',
        email: '',
        image: '',
    });

    const loadProfile = async () => {
        try {
            setLoading(true);
            const data = await recruitmentCompanyService.getProfile();

            // Handle possible response shapes
            const company = data?.data ?? data;
            setForm({
                name: company?.name ?? '',
                bio: company?.bio ?? '',
                address: company?.address ?? '',
                site_link: company?.site_link ?? '',
                email: company?.email ?? '',
                image: company?.image ?? '',
            });
        } catch (error) {
            const message = error?.response?.data?.message || t('company.profile.loadFailed');
            toast.error(message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadProfile();
    }, []);

    if (loading) {
        return <Loader fullScreen={true} size="large" />;
    }

    // company avatar like employee profile
    const companyName = form.name || t('company.profile.name') || 'شركة توظيف';
    const companyImage = form.image ? (form.image.startsWith('http') ? form.image : `${STORAGE_BASE_URL}/${form.image}`) : user?.image;

    return (
        <div className="employee-profile-page" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
            <RecruitmentCompanyNav user={user} />

            {/* Picture and name like employee profile */}
            <div className="profile-picture-container d-flex justify-content-center flex-wrap mb-4">
                <div className="profile-picture-large position-relative">
                    {companyImage ? (
                        <img
                            src={companyImage}
                            alt="Recruitment Company"
                            className="profile-img-large"
                        />
                    ) : (
                        <div className="profile-img-large text-center align-content-center">
                            <b style={{ fontSize: '4rem' }}>{companyName.charAt(0).toUpperCase()}</b>
                        </div>
                    )}
                </div>
                <p className="d-block w-100 text-center">{companyName}</p>
            </div>

            {/* Basic info section (view) */}
            <div className="profile-section px-3 mb-4">
                <div className="section-header d-flex justify-content-between align-items-center mb-2">
                    <h3 className="section-title">{t('company.profile.title')}</h3>
                    <button
                        onClick={() => navigate('/recruitment-company/edit-profile')}
                        className="btn-apply"
                        style={{
                            background: 'linear-gradient(135deg, #608fd3 0%, #4a7bc4 100%)',
                            color: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: '0.5rem',
                            fontSize: '0.9rem',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        {t('company.profile.edit') || 'تعديل'}
                    </button>
                </div>
                <ul className="education-details">
                    <li>{form.email || '—'}</li>
                    <li>{form.site_link || '—'}</li>
                    <li>{form.address || '—'}</li>
                </ul>
            </div>

            {/* About section */}
            <div className="profile-section px-3 mb-4">
                <div className="section-header d-flex justify-content-between align-items-center mb-2">
                    <h3 className="section-title">{t('company.profile.bio')}</h3>
                </div>
                <p className="section-text">{form.bio || t('company.profile.noBio') || 'No company bio added yet.'}</p>
            </div>

            <RecruitmentCompanyBottomNavigation />
        </div>
    );
};

export default RecruitmentCompanyProfile;

